import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/settings/tip_jar_empty.svg")